/**
 * pc-article-flat-toc.js
 * 从文章正文中提取 H2 标题，生成 Table of Contents 并高亮当前可视 heading。
 */
(function () {
  'use strict';

  var content = document.querySelector('[data-component="article-flat-body"] [data-bind="content"]');
  var tocList = document.querySelector('[data-component="article-flat-body"] [data-bind="toc-list"]');
  if (!content || !tocList) return;

  var headings = content.querySelectorAll('h2');
  if (headings.length === 0) {
    var tocAside = document.querySelector('[data-component="article-flat-body"] [data-bind="toc"]');
    if (tocAside) tocAside.style.display = 'none';
    return;
  }

  var skipPatterns = /^(FAQ|FAQs|Conclusion|References|Sources)$/i;
  var filtered = Array.prototype.filter.call(headings, function (h) {
    return !skipPatterns.test(h.textContent.trim());
  });

  if (filtered.length === 0) {
    var tocAside2 = document.querySelector('[data-component="article-flat-body"] [data-bind="toc"]');
    if (tocAside2) tocAside2.style.display = 'none';
    return;
  }

  var fragment = document.createDocumentFragment();
  filtered.forEach(function (h, i) {
    if (!h.id) {
      h.id = 'section-' + (i + 1);
    }
    var link = document.createElement('a');
    link.href = '#' + h.id;
    var span = document.createElement('span');
    span.textContent = h.textContent.trim();
    link.appendChild(span);
    fragment.appendChild(link);
  });
  tocList.appendChild(fragment);

  var tocLinks = tocList.querySelectorAll('a');
  var currentActive = null;

  function setActive(index) {
    if (currentActive === index) return;
    if (currentActive !== null && tocLinks[currentActive]) {
      tocLinks[currentActive].removeAttribute('data-active');
    }
    currentActive = index;
    if (tocLinks[index]) {
      tocLinks[index].setAttribute('data-active', '');
    }
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var idx = filtered.indexOf(entry.target);
        if (idx !== -1) setActive(idx);
      }
    });
  }, {
    rootMargin: '-80px 0px -60% 0px',
    threshold: 0
  });

  filtered.forEach(function (h) { observer.observe(h); });

  tocList.addEventListener('click', function (e) {
    var link = e.target.closest('a');
    if (!link) return;
    e.preventDefault();
    var target = document.getElementById(link.getAttribute('href').slice(1));
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', link.getAttribute('href'));
    }
  });
})();
